import { ButtonHTMLAttributes, ReactNode } from 'react';

interface AcaoIconeProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'padrao' | 'perigo';
  icon: ReactNode;
}

export function AcaoIcone({ tone = 'padrao', icon, style, ...props }: AcaoIconeProps) {
  const perigo = tone === 'perigo';

  return (
    <button
      type="button"
      {...props}
      style={{
        width: '34px',
        height: '34px',
        borderRadius: '8px',
        border: `1px solid ${perigo ? 'rgba(224,41,62,0.3)' : 'rgba(30,86,232,0.25)'}`,
        background: perigo ? 'rgba(224,41,62,0.06)' : 'rgba(30,86,232,0.06)',
        color: perigo ? 'var(--cor-erro)' : 'var(--cor-primaria)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        flexShrink: 0,
        ...style,
      }}
    >
      {icon}
    </button>
  );
}
